import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { PipelineFailedDocument } from "@/types/contract-family-pipeline";

export const FailedSnapshotsDialog = ({
  open,
  documents,
  onOpenChange,
  onConfirm,
  isLoading,
}: {
  open: boolean;
  documents: PipelineFailedDocument[];
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading: boolean;
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Continue without failed documents?</DialogTitle>
        <DialogDescription>The listed documents will be excluded from this workflow.</DialogDescription>
      </DialogHeader>
      <ul className="max-h-64 list-disc overflow-auto pl-5 text-sm">
        {documents.map(document => (
          <li key={document.document_id}>{document.name}</li>
        ))}
      </ul>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={isLoading || documents.length === 0}>
          {isLoading ? "Continuing…" : "Continue without failed documents"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
